module.exports = __webpack_public_path__ + "images/anwbassurantien_smalla8e371783fae1fe1fac2bcf4f1c29e88.png";